import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const HiddenInputs = styled.div(
  ({ hidden = true }: { hidden?: boolean }) =>
    hidden
      ? {
          display: 'none',
          visibility: 'hidden'
        }
      : {}
)

export const SpinnerInputWrapper = styled.div(() => ({
  borderRadius: '4px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #dbd9df'
}))

export const courierFormHeaderStyles = css`
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafb;
`

export const CourierFormHeader = styled.div`
  ${courierFormHeaderStyles}
`
